import { runClientComponent } from '../../_common/client/client-component-runner';
import { InstallmentPlanExampleComponent } from './installment-plan-example.component';

runClientComponent({ InstallmentPlanCalculatorExampleComponent: InstallmentPlanExampleComponent });
